/**
 * The product's identity, in one place. Everything that names the product (titles, emails,
 * calendar files, backups, the shell) reads these; see docs/brand.md.
 */
export const BRAND = {
  name: "Blurtake",
  /** The one-line promise, for welcome moments only. */
  tagline: "Every great song starts messy.",
  /** What it does, for descriptions and the install prompt. */
  line: "Capture ideas. Shape songs. Pitch with confidence.",
  description: "A creative workspace for songwriters and producers.",
} as const;

export const APP_NAME = BRAND.name;
